module.exports = __webpack_public_path__ + "img/slika51.8d2ed572.jpg";